import type { GooglePlaceDto } from '@up2stay/up2promo-api-client';

import type { LocationAddressDetails } from '@/core/components/locations/location-details-form';

export function addressDetailsFromPlace(
  place: GooglePlaceDto,
): LocationAddressDetails {
  return {
    formatted: place.address ?? null,
    postalCode: place.postalCode ?? null,
    street: place.street ?? null,
    streetNumber: place.streetNumber ?? null,
    locality: place.locality ?? null,
    administrativeArea: place.administrativeArea ?? null,
    administrativeAreaLevel2: place.administrativeAreaLevel2 ?? null,
    country: place.country ?? null,
    countryCode: place.countryCode ?? null,
  };
}
